<template>
  <div class="home">
    <div class="banner">
      <img class="bgImg" src="../asset/aike/hbanner.png" alt="">
    </div>
      <div class="main" id="div1">
        <div class="title wow fadeInUp">
          {{$t('human').text0}}
        </div>
        <div class="chose wow fadeInUp">
          <div class="year">
            <el-select v-model="value" :placeholder="$t('human').text1" @change="getJob">
              <el-option
                      v-for="(item,index) in data.job"
                      :key="index"
                      :label="item"
                      :value="item">
              </el-option>
            </el-select>
          </div>
          <div class="month">
            <el-select v-model="value2" :placeholder="$t('human').text2" @change="getAddress">
              <el-option
                      v-for="(item,index) in data.address"
                      :key="index"
                      :label="item"
                      :value="item">
              </el-option>
            </el-select>
          </div>


        </div>
        <div class="allItems ">
              <div class="aTitle wow fadeInUp">
               <span> {{$t('human').text3[0]}}</span>
                <span>{{$t('human').text3[1]}}</span>
                <span>{{$t('human').text3[2]}}</span>
                <span>{{$t('human').text3[3]}}</span>
                <span>{{$t('human').text3[4]}}</span>
                <span>{{$t('human').text3[5]}}</span>
                <span>{{$t('human').text3[6]}}</span>
              </div>
          <div class="item wow fadeInUp" v-for="(item,index) in data.human" :key="index">
           <span>{{item.title}}</span>
            <span>{{item.diy_1}}</span>
            <span>{{item.diy_2}}</span>
            <span>{{item.diy_3}}</span>
            <span>{{item.diy_4}}</span>
            <span>{{item.posttime}}</span>
            <span @click="showDia(item.content)">
              <img src="../asset/aike/show.png" alt="">
            </span>
          </div>
        </div>

        <div class="page wow fadeInUp">
          <el-pagination
                  background
                  layout="prev, pager, next"
                  @current-change="handleCurrentChange"
                  :page-count="totalPage">
          </el-pagination>
        </div>
      </div>

    <div class="dialog" v-if="isShow">
       <div class="content animated fadeIn" :style="aStyle">
         <div class="close" @click="closeDia">
           <i class="el-icon-circle-close"></i>
         </div>
           <div class="html" v-html="content">
<!--             岗位要求：<br>-->
<!--             1、男生（23~35岁）；<br>-->
<!--             2、一年工作经验以及上<br>-->
<!--             <br>-->
<!--             联系人：邹小姐/ Hr Dept<br>-->
<!--             联系方式：+0086 57487432748<br>-->
<!--             邮箱： hr@icoolglobal.com<br>-->
<!--             网址： http://www.icoolglobal.com<br>-->
<!--                　　　 http://www.ninhua.cn-->
           </div>
         <a class="btn" href="mailto:admin@admin.com">{{$t('human').text4}}</a>
       </div>
    </div>



    <foot></foot>
  </div>
</template>

<script>
import foot from "@/components/foot.vue";
import Scrollbar from 'smooth-scrollbar';
import {getHuman} from "../util/lang";

export default {
  name: "home",
  data() {
    return {
        page:1,
        content:'',
      isShow:false,
      aStyle:'',
      totalPage:10,
        scrollbar:'',
      value: '',
      value2: '',
        data:'',
    };
  },
  mounted() {
      Scrollbar.initAll(document.getElementById("scroller-wrapper"));
      this.scrollbar = Scrollbar.get(document.getElementById("scroller-wrapper"));
      this.scrollbar.scrollTo(0, 1);
      this.scrollbar.addListener((status) => {
          if(document.body.clientWidth<=1000){
              this.aStyle={'marginTop':status.offset.y+120+'px'}
          }else{
              this.aStyle={'marginTop':status.offset.y+180+'px'}
          }

          window.pageYOffset = this.scrollbar.scrollTop;
      });
      setTimeout(()=>{
          this.getContent()
          Scrollbar.get(
              document.getElementById("scroller-wrapper")
          ).scrollIntoView(document.querySelector("#div1"), {
              offsetTop: 150
          });
      },100)
  },
  components: {foot},
  methods:{
      getJob(val){
          this.value=val
          const url = `${getHuman(this.value,this.value2,this.page)}`
          this.$axios.get(url).then(res => {
              this.data=res.data
          })
      },
      getAddress(val){
          this.value2=val
          const url = `${getHuman(this.value,this.value2,this.page)}`
          this.$axios.get(url).then(res => {
              this.data=res.data
          })
      },
      getContent(){
          const url = `${getHuman('','',1)}`
          this.$axios.get(url).then(res => {
              this.data=res.data
              this.totalPage=res.data.pages
          })
      },
    showDia(n){
          this.content=n
      this.isShow=true
    },
    closeDia(){
       this.isShow=false
    },
    handleCurrentChange(val) {
          this.page=val
      if(val<=this.totalPage){
          this.$nextTick(()=>{
              const url = `${getHuman(this.value,this.value2,val++)}`
              this.$axios.get(url).then(res => {
                  this.dList=res.data.data
              })
          })
      }else{
          this.$notify({
              title: 'Prompt',
              message: 'Already Loaded',
              offset: 100
          });
      }
    }
  }
};
</script>
<style  lang="scss" scoped>
.home{
  width:100%;
  position: relative;
  .banner{
    width:100%;
    height:100vh;
      position: relative;
      overflow: hidden;
    .bgImg{
      width:100%;
      display: block;
      object-fit: cover;
      height:100%;
        animation: sbig 5s linear forwards;
    }
      @keyframes sbig {
          from{
              transform: scale(1);
          }
          to{
              transform: scale(1.05);
          }
      }

  }
  .main{
    width:70%;
    margin: 60px auto;
    .title{
      text-align: center;
      font-size: 38px;
      font-family: "SOURCEHANSANSCN-BOLD";
        animation-duration: 2s;
    }
    .chose{
      width:100%;
      display: flex;
      flex-direction: row;
      margin:40px auto;
      margin-left: 2%;
        animation-duration: 2s;
      .month{
        margin-left: 20px;
      }
    }
    .allItems{
      width:100%;
      .aTitle{
        width:100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
          animation-duration: 2s;
        span{
          font-family: "SOURCEHANSANSCN-BOLD";
          font-size: 20px;
          color:#666666;
          width:15%;
          display: inline-block;
          text-align: center;
        }
      }
      .item{
        width:100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
          animation-duration: 2s;
        background:rgba(255,255,255,1);
        box-shadow:1px 2px 5px 1px rgba(0, 0, 0, 0.1);
        padding: 20px 0;
        margin-top: 30px;
        span{
          width:15%;
          display: inline-block;
          text-align: center;
          color:#666666;
          font-family: "SOURCEHANSANSCN-REGULAR";
          img{
            cursor: pointer;
          }
        }
      }
    }
    .page{
      text-align: center;
      margin: 80px auto;
    }
  }
  .dialog{
    position: absolute;
    left:0;
    top:0;
    width:100%;
    height:100%;
    background-color: rgba(0,0,0,.5);
    z-index: 100;
    .content{
      width:30%;
      background-color: white;
      padding: 30px;
      margin: 0 auto;
      position: relative;
      .close{
        position: absolute;
        right:10px;
        top:10px;
        i{
          font-size:30px;
          cursor: pointer;
          display: inline-block;
          transition: all 600ms;
          transform: rotate(45deg);
        }
        &:hover{
          i{
            transform: rotate(0);
          }
        }
      }
      .html{
        color:#666666;
        font-family: "SOURCEHANSANSCN-REGULAR";
        line-height: 40px;
      }
      .btn{
        width:160px;
        height:34px;
        border:1px solid #019bdb;
        display: inline-block;
        text-align: center;
        line-height: 34px;
        color:#666666;
        font-family: "SOURCEHANSANSCN-REGULAR";
        margin-top: 30px;
        position: relative;
        transition: all 600ms;
        &::after{
          position: absolute;
          top: 0;
          left: 0;
          display: inline-block;
          content: "";
          background-color: #019bdb;
          width: 0;
          height: 100%;
          -webkit-transition: all 600ms;
          transition: all 600ms;
          z-index: -1;
        }
        &:hover{
          color:white;
          &::after{
            width:100%;
          }
        }
      }
    }
  }
    @media screen and (max-width: 1000px){
        .main{
            width:90%;
            margin: 30px auto;
            .title{
                font-size: 24px;
            }
            .allItems{
                .aTitle{
                    span{
                        font-size: 14px;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 1;
                        overflow: hidden;
                    }
                }
                .item{
                    span{
                        font-size: 14px;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 1;
                        overflow: hidden;
                        height:25px;
                        line-height: 30px;
                    }
                }
            }
            .page{
                margin: 30px auto;
            }
        }
        .dialog{
            .content{
                width:70%;
                padding: 20px 5%;
            }
        }
    }
}
</style>
